import { serverPath } from "@lib/server"
import { LottieAnimation } from "@lib/animations"

export function NotFoundAnimation() {
  return (
    <div className="relative flex justify-end max-w-[16.25rem] w-full mobile-m:max-w-[22.5rem] tablet:max-w-[33.813rem] tablet-lg:max-w-[26.75rem] desktop:max-w-desktop">
      <LottieAnimation
        path={serverPath("/static/animations/404.json")}
        className="w-full flex h-[200px] mobile-m:h-[278px] tablet:h-[420px] tablet-lg:h-[332px] laptop:h-[332px] desktop:h-[465px] desktop-l:h-[526px]"
        settings={{
          preserveAspectRatio: "xMaxYMid meet",
        }}
      />
    </div>
  )
}
